import { useState, useEffect } from "react";
import { apiFetch, type SingleResponse } from "../lib/api.ts";

export interface Stats {
  total_projects: number;
  total_categories: number;
  languages: string[];
}

export function useStats() {
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiFetch<SingleResponse<Stats>>("/stats")
      .then((res) => {
        if (!cancelled) setStats(res.data);
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return { stats, loading };
}
